import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { TextInput } from "@/components";
import { ContainedButton } from "@/common";

export const StyledTextInput = styled(TextInput)({
  borderColor: "#C0C4C4",
  backgroundColor: "#fff",
  borderRadius: "6px",
  flexGrow: 1,
  minWidth: "200px",
  maxWidth: "300px",
});
export const StyledContainedButton = styled(ContainedButton)({
  borderRadius: "6px",
  boxShadow: "0px 2px 4px rgba(16, 24, 40, 0.05)",
  flexShrink: 0,
  width: "auto",
  padding: "8px 16px",
});

export const HeaderRightNode = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  height: "100%",
  width: "auto",
  "@media (min-width: 996px) and (max-width: 1104px)": {
    width: "60%",
  },
  "@media (max-width: 528px)": {
    flexWrap: "wrap",
    justifyContent: "center",
  },
});
